<template>
  <div>
    <!-- status -->
    <div class="order-status-container">
      <div
        :class="status === '' ? 'status-item active' : 'status-item' "
        @click="onChangeStatus('')"
      >全部订单</div>
      <div
        :class="status === 0 ? 'status-item active' : 'status-item'"
        @click="onChangeStatus(0)"
      >待确认</div>
      <div
        :class="status === 1 ? 'status-item active' : 'status-item'"
        @click="onChangeStatus(1)"
      >已确认</div>
    </div>
    <!-- body -->
    <div class="order-list-wrap">
      <cube-scroll
        ref="contentScroll"
        class="scroll-wrap"
        :data="data"
        :options="options"
        @pulling-up="onPullingUp"
        @pulling-down="onPullingDown"
      >
        <div class="nodata" v-if="!data.length">没有到任何数据!</div>
        <div class="order-list" v-if="data.length">
          <van-panel
            :title="'订单号:'+item.ordersn"
            :status="item.status_txt"
            :class="item.status_class"
            v-for="(item,index) in data"
            class="order-item"
          >
            <div class="order-info">
              <p>下单时间：{{item.create_time}}</p>
              <p>地区：{{item.address}}</p>
              <p>店铺名称：{{item.username}}</p>
              <p class="remark" v-if="item.isparent==0">
                <span>备注：</span>
                <span class="remark-input">
                  <input
                    type="text"
                    @change="onSetRemark(item.id,index)"
                    v-model="item.remark"
                    placeholder="这里可以填写备注"
                  />
                </span>
              </p>
            </div>
            <div slot="footer" class="order-footer order-buttons">
              <van-button
                v-if="type == 'admin' && item.isparent==0"
                size="small"
                type="primary"
                @click="$emit('setstatus',{orderid:item.id,status: 1})"
              >已确认</van-button>
              <van-button
                v-if="type == 'admin' && item.isparent==0"
                size="small"
                type="warning"
                @click="$emit('setstatus',{orderid:item.id,status: 0})"
              >待确认</van-button>
              <van-button
                size="small"
                type="danger"
                v-clipboard:copy="item.ordersn"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >复制订单号</van-button>
              <van-button
                size="small"
                v-if="type == 'admin' && item.isparent==1"
                type="info"
                @click="$emit('print',{orderid:item.id,merchname: item.username})"
              >打印汇总</van-button>
              <van-button
                size="small"
                v-if="type == 'admin' && item.isparent==1"
                type="info"
                @click="$emit('tochild',item.id)"
              >查看子单</van-button>
              <van-button
                size="small"
                v-if="type == 'admin' && item.isparent==1"
                type="info"
                @click="$emit('tosummary',item.id)"
              >查看汇总</van-button>

              <van-button
                size="small"
                v-if="item.iscancel && item.isparent==0"
                type="default"
                @click="$emit('cancelorder',item.id)"
              >取消订单</van-button>
              <van-button
                size="small"
                v-if="item.isparent == 0"
                type="info"
                @click="$emit('todetail',item.id)"
              >查看详情</van-button>
            </div>
          </van-panel>
        </div>
      </cube-scroll>
    </div>
  </div>
</template>
<script>
import { OrderModel } from "@models/common/order";
const orderModel = new OrderModel();
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    totalpage: {
      type: Number,
      default: 1
    },
    page: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: "merch"
    }
  },
  data() {
    return {
      status: "",
      options: {
        pullDownRefresh: {
          threshold: 60,
          stopTime: 500,
          txt: "刷新成功"
        },
        pullUpLoad: {
          txt: {
            noMore: "没有了"
          }
        }
      }
    };
  },
  methods: {
    onPullingUp() {
      if (this.page < this.totalpage) {
        setTimeout(() => {
          this.$emit("loadmore", this.status);
        }, 1000);
      } else {
        this.$refs.contentScroll.forceUpdate();
      }
    },
    onPullingDown() {
      this.$emit("pullingDown", this.status);
    },
    onChangeStatus(status) {
      this.status = status;
      this.$emit("change", status);
    },
    onCopy() {
      this.$toast("复制成功");
    },
    onError() {
      this.$toast("复制失败");
    },
    onSetRemark(id, index) {
      orderModel
        .setRemark({
          orderid: id,
          data: this.data[index].remark
        })
        .then(res => {
          if (res.data == 1) {
            this.$toast("设置成功!");
          } else {
            this.$toast("设置失败!");
          }
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.order-item {
  margin-bottom: 0.2rem;
}

>>>.van-cell__title {
  -webkit-box-flex: auto;
  -webkit-flex: auto;
  flex: auto;
  width: 4rem;
}

>>>.van-panel__content {
  padding: 0.2rem 0.3rem;
}

.order-info p {
  line-height: 1.8;
  color: #aaa;
}

.order-footer {
  display: flex;
  justify-content: flex-end;
}

.order-status-container {
  width: 100%;
  height: 0.86rem;
  background: #fff;
  position: fixed;
  top: 0.92rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-item {
  width: 25%;
  height: 100%;
  line-height: 0.86rem;
  text-align: center;
  color: #aaa;
}

.status-item.active {
  color: #000;
}

.scroll-wrap {
  height: calc(100% - 2rem);
  position: fixed;
  top: 2rem;
  width: 100%;
}

.navbar {
  color: #fff;
  background: #2196f3;
  position: fixed;
  top: 0;
  width: 100%;
}

>>>.status0 .van-panel__header-value span {
  padding: 0.1rem 0.2rem;
  background: #f60;
  color: #fff;
  border-radius: 5px;
}

>>>.status1 .van-panel__header-value span {
  padding: 0.1rem 0.2rem;
  background: #67c23a;
  color: #fff;
  border-radius: 5px;
}

>>>.status_1 .van-panel__header-value span {
  padding: 0.1rem 0.2rem;
  background: #ccc;
  color: #fff;
  border-radius: 5px;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.order-buttons button {
  margin-left: 0.2rem;
}

.remark {
  display: flex;
  align-items: center;
}

.remark .remark-input input {
  position: relative;
  top: -0.02rem;
  font-size: 0.24rem;
  color: #000;
}
</style>